import React, {Component} from 'react';
//import TestData from './data'
import {Button} from 'semantic-ui-react'
import DocumentCreatorForm from '../documenti/DocumentCreatorForm'
import LoadingFrame from '../LoadingFrame'
import ErrorMessageTiny from '../ErrorMessageTiny'
import {client} from '../../Client';
import FileSaver from 'file-saver';
import {copiaTestoNegliAppunti} from '../../Helpers';
import Moment from 'moment';
import PropTypes from 'prop-types';

class GareDocumentCreator extends Component {
    constructor(props) {
        let idDivisione = undefined;
        if (client.getConfigurazione() && client.getConfigurazione().idDivisione){
            idDivisione = client.getConfigurazione().idDivisione.idDivisione
        }
        super(props);
        this.state = {
            gara: this.props.gara,
            senders: [],
            idDivisione: idDivisione,
            anno: Moment().format('Y'),
            codiceTipoDocumento: '',
            documentoCreato: null,
            _loading:false,
            error: null
        };
    }

    isVisible(){
        return (this.state.gara && this.state.gara.ragioneSociale !== '');
    }

    canSave(){
        let rv = (
            this.state.gara !== undefined &&
            this.state.idDivisione !== undefined &&
            this.state.codiceTipoDocumento !== undefined &&
            this.state.codiceTipoDocumento.trim() !== '' &&
            this.state.anno !== undefined &&
            this.state.anno !== '' &&
            this.state.anno.length === 4 &&
            /^[1-9][0-9][0-9][0-9]$/.test(this.state.anno) &&
            this.state.gara.ragioneSociale !== ''
        )
        return rv;
    }

    componentWillReceiveProps(nextProps){

        let newState = undefined;

        if (nextProps.idDivisione !== this.props.idDivisione){
            newState = {
                idDivisione: nextProps.idDivisione
            }
        }
        if (nextProps.gara !== this.props.gara){
            newState = {
                gara: nextProps.gara
            }
        }
        if (newState){
            this.setState(newState);
        }
    }

    onRubricaCreatorFormChange({idDivisione, codiceTipoDocumento, anno}) {
        this.setState({idDivisione, codiceTipoDocumento, anno});
    }

    onDownload(documento){
        this.setState({_loading: true})
        client.downloadDocument(documento.idDocumento).then(
            (response) => {
                if (response.ok){
                    response.blob().then((blob) => {
                        this.setState({_loading: false, error: null})
                        FileSaver.saveAs(blob, documento.nome);
                    })
                }
                else if (response.status === 401)
                {
                    this.context.router.transitionTo("/login")
                }
                else
                {
                    response.json().then((errore) => {
                        this.setState({
                            _loading: false,
                            error: {title: errore.title, msg: errore.msg},
                        });
                    });
                }
            }).catch((error) => {
            this.setState({
                _loading: false,
                error: {title: "Errore di rete imprevisto", msg: error.message},
            });

        });
    }

    onSaveClick(){
        let destinatari = [];

        this.setState({_loading: true});
        client.saveDocumento(
            {
                idGara: this.state.gara.idGara,
                codiceTipoDocumento: this.state.codiceTipoDocumento,
                idDivisione: this.state.idDivisione,
                creatoDa: client.getCurrentUserId(),
                macro: {destinatari, idGara: this.state.gara.idGara, idDivisione: this.state.idDivisione},
                anno: this.state.anno
            }
        ).then((response) => {
            if (response.ok){
                response.json().then((data) => {
                    this.setState({
                        _loading: false,
                        error: null,
                        documentoCreato: data
                    });
                    //this.onDownload(data);

                })
            }
            else if (response.status === 401)
            {
                this.context.router.transitionTo("/login")
            }
            else
            {
                response.json().then((errore) => {
                    this.setState({
                        _loading: false,
                        error: {title: errore.title, msg: errore.msg},
                    });
                })
            }
        }).catch((error) => {
            this.setState({
                _loading: false,
                error: {title: "Errore di rete imprevisto", msg: error.message},
            });
        });
    }

    onCopiaTesto(value){
        copiaTestoNegliAppunti(value);
    }

    render() {

        if (!this.isVisible())
        {
            return null;
        }

        let documentoCreatoMsg = null;
        if (this.state.documentoCreato){
            documentoCreatoMsg = <div className="row">
                <div className="sixteen wide column">
                    <div className="ui info message">
                        <i className="close icon"></i>
                        <div className="header">
                            Documento <small>{this.state.documentoCreato.nome}</small> creato correttamente
                        </div>
                        <ul className="list">
                            <li className="pointer" onClick={() => this.onCopiaTesto(client.adaptClientPath(this.state.documentoCreato.clientFullname))}><i className="icon copy"/> Clicca qui per copiare il path locale del documento sugli appunti.</li>
                            {/* <li className="pointer" onClick={() => this.onDownload(this.state.documentoCreato)}><i className="icon download"/> Clicca qui per effettuare il download del documento.</li> */}
                        </ul>
                    </div>
                </div>
            </div>
        }

        let buttonClose = null;
        if (this.props.onCloseClick){
            buttonClose = (
                <Button  onClick={() => (this.props.onCloseClick())}><i className="close icon"/>Chiudi</Button>
            )
        }

        return (
            <div className="no-print ui raised segment">
                <h4 className="ui header">Creazione Documento</h4>
                <div className="ui grid one column stackable">
                    {documentoCreatoMsg}
                    <div className="row">
                    <div className="sixteen wide column">
                        <DocumentCreatorForm
                            codiceTipoDocumento={this.state.codiceTipoDocumento}
                            idDivisione={this.state.idDivisione}
                            anno={this.state.anno}
                            inGare={true}
                            onChange={(fields) => (this.onRubricaCreatorFormChange(fields))}
                        />
                        <div className="ui grid">
                            <div className="center aligned sixteen wide column">
                                <Button primary onClick={() => (this.onSaveClick())} disabled={!this.canSave() || this.state.documentoCreato != null}><i className="save icon"/>Crea Documento</Button>
                                {buttonClose}
                            </div>
                        </div>
                    </div>
                    </div>


                </div>
                <LoadingFrame visible={this.state._loading}/>
                <ErrorMessageTiny error={this.state.error}  />
            </div>
            )
    }
}

GareDocumentCreator.PropTypes = {
    idDivisione: PropTypes.number.isRequired,
    gara: PropTypes.object.isRequired,
    onCloseClick: PropTypes.func
}

GareDocumentCreator.contextTypes = {
    router: PropTypes.object
}
export default GareDocumentCreator;



/** WEBPACK FOOTER **
 ** ./src/components/gare/GareDocumentCreator.js
 **/